// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/StarRating.scss
// module id = ./src/styles/StarRating.scss
// module chunks = 0